import {StyledFAQNoteBox, StyledFAQNoteAlert} from './FaqStyles'
import IconComponent from '../Dashboard/percentagePopup/IconComponent'
import ContentComponent from '../Dashboard/percentagePopup/ContentComponent'

const GlobalNoteComponent = () => (
  <StyledFAQNoteBox>
    <StyledFAQNoteAlert severity='info' icon={<IconComponent />}>
      <ContentComponent />
    </StyledFAQNoteAlert>
  </StyledFAQNoteBox>
)

export default GlobalNoteComponent
